import { render, staticRenderFns } from "./contracts_orders.vue?vue&type=template&id=d65995a4&scoped=true"
import script from "./contracts_orders.vue?vue&type=script&lang=js"
export * from "./contracts_orders.vue?vue&type=script&lang=js"
import style0 from "./contracts_orders.vue?vue&type=style&index=0&id=d65995a4&prod&scoped=true&lang=scss"
import style1 from "./contracts_orders.vue?vue&type=style&index=1&id=d65995a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65995a4",
  null
  
)

export default component.exports